import PropTypes from 'prop-types';

export const UserDateTimePropType = PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]);

/**
 * @typedef  {(string|Date)} UserDateTimePropType
 */
